<template>
  <div
    class="card mt-3"
    :style="{ 'min-height': $store.state.screenHeight - 100 + 'px' }"
  >
    <div class="card-body text-center">
      <!-- <h1 style="font-weight: bold;">{{ title }}</h1> @change="getTransferAll(), getUserAll(), getProductAll(), getAll()" -->
      <div class="container">
        <div class="row">
          <div class="row col-4 pb-2">
            <label for="date" class="col-sm-3 col-form-label text-right pb-0">เลือกสาขา</label>
            <div class="col-sm-9 pb-0">
              <select
                class="custom-select mr-sm-2 pb-0"
                id="Branch"
                v-model="branch"
                @change="getTransferAll()"
              >
                <option value=0>-- ทุกสาขา --</option>
                <option
                  v-for="(b, i) in $store.state.branch_list"
                  :key="'branch' + i"
                  :value="b"
                  >{{ b.branch_name }}</option
                >
              </select>
            </div>
          </div>
          <div class="row col-8 pb-2">
            <label for="date" class="col-sm-2 col-form-label text-right pb-0">ค้นหา</label>
            <div class="col-sm-10 pb-0">
                <input
                  type="text"
                  class="form-control"
                  @keyup="onSearch"
                  v-model="search"
                  @keypress="onChange(1)"
                  placeholder="กรอกชื่อสินค้าหรือสถานะ...."
                />
            </div>
          </div>
          <div class="row col-4 pb-2">
              <label for="date" class="col-sm-3 col-form-label text-right">วันที่เริ่ม</label>
              <div class="col-sm-9 pb-0">
                <a-date-picker
                  v-model="startDate"
                  :format="'DD/MM/YYYY'"
                  style="width: 100%;"
                  :disabledDate="selectDateStart"
                  @change="onSerchDate"
                />
              </div>
          </div>
          <div class="row col-8 pb-2">
            <label for="date" class="col-sm-2 col-form-label text-right">ถึงวันที่</label>
              <div class="col-sm-5">
                <a-date-picker
                  v-model="endDate"
                  :format="'DD/MM/YYYY'"
                  style="width: 100%;"
                  :disabledDate="selectDateEnd"
                  @change="onSerchDate"
                />
              </div>
            <div class="col-sm-5 pb-0" style="text-align:left;">
              <form
                action="/static/excel/report_transfer_stock.php"
                method="POST"
                target="_blank"
              >
                <input
                  type="hidden"
                  name="date_start"
                  v-model="startDate"
                >
                <input
                  type="hidden"
                  name="date_end"
                  v-model="endDate"
                >
                <input
                  type="hidden"
                  name="data"
                  v-model="form_data"
                >
                <button
                  type="submit"
                  class="btn btn-primary"
                  style="width: 100%; background-color:#17a2b8; border-color:#17a2b8;"
                >
                    <i class="fas fa-file-excel"></i> บันทึกเป็น Excel
                </button>
              </form>
            </div>
          </div>
        </div>
        <div class="table-responsive">
          <table class="table">
            <thead class="thead-dark">
              <tr>
                <th scope="col">#</th>
                <th scope="col">รหัสคำสั่งซื้อ</th>
                <th scope="col">เวลา</th>
                <th scope="col">รายการสินค้า</th>
                <th scope="col">หน่วยนับ</th>
                <th scope="col">จำนวน</th>
                <th scope="col">สาขาสั่งซื้อ</th>
                <th scope="col">สาขาที่โอนออก</th>
                <th scope="col">สถานะ</th>
                <th scope="col">ดำเนินการ</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(d, i) in paginate" :key="'cus' + i">
                <td class="text-center p-1">{{ i+1 }}</td>
                <td class="text-center p-1">{{ d.transfer_code }}</td>
                <td class="text-center p-1">
                  {{ d.transfer_date }}
                </td>
                <td class="text-right p-1">
                  <div v-for="(p, x) in d.product" :key="'product' + x">
                    <p style="text-align:left;" v-if="p.item !== null">{{ p.item.name }}</p>
                  </div>
                </td>
                <td class="text-right p-1">
                  <div v-for="(p, x) in d.product" :key="'product' + x">
                    <p style="text-align:left;" v-if="p.item !== null">{{ p.item.stk_unit_code }}</p>
                  </div>
                </td>
                <td class="text-left p-1">
                  <div v-for="(p, x) in d.product" :key="'product' + x">
                    <p style="text-align:center;">{{ p.amount }}</p>
                  </div>
                </td>
                <td class="text-center p-1">
                  {{ d.branch_in_name }}
                </td>
                <td class="text-center p-1">
                  {{ d.branch_out_name }}
                </td>
                <td class="text-center pb-1" :class="[d.status === 'Cancel' ? 'status-cancel' : d.status === 'Success' ? 'status-success' : d.status === 'Waiting' ? '' : 'status-waiting']">
                  {{ d.transfer_status }}
                </td>
                <td class="text-center p-1">
                  <button
                  type="button"
                  style="font-size: 20px;"
                  :class="[d.status == 'Cancel' || d.status == 'Success' || d.status == 'PaddingConfirm' ? 'btn pt-0 pb-0 btn-secondary-stock' : 'btn pt-0 pb-0 btn-warning-stock']"
                  @click="
                  modal_active = true;
                  modal_title = 'รายละเอียด';
                  modal_data = d
                  branchOut = '0'
                  getHaveStock()
                  "
                >
                    <div >
                      <img v-if="d.status == 'Cancel' || d.status == 'Success' || d.status == 'PaddingConfirm'" src="../assets/search.png" />
                      <img v-else src="../assets/pen.png" />
                    </div>
                </button>
                <button
                  type="button"
                  style="font-size: 20px;"
                  :class="['btn pt-0 pb-0 btn-danger']"
                  @click="
                  deleteItem(d)
                  "
                  v-if="d.status == 'Success'" 
                >
                  <i class="fas fa-trash"></i>
                </button>
                </td>
              </tr>
              <tr>
                <th
                  scope="row"
                  colspan="10"
                  class="text-center"
                  v-if="transfer_data.length < 1"
                >
                  ไม่มีข้อมูล
                </th>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          id="components-pagination-demo-mini"
          class="d-flex justify-content-end"
          v-if="transfer_data.length > items_perpage"
        >
          <a-pagination
            size="large"
            :total="transfer_data.length"
            :itemRender="itemRender"
            @change="onChange"
            v-model="currentPage"
          />
        </div>

        <a-modal
          :title="modal_title"
          centered
          v-model="modal_active"
          :footer="null"
          width="900px"
        >
          <div class="container p-1">
            <div class="container row" style="font-size:1rem;">
              <div class="col-sm-12" style="font-size:1.2rem;color:#7DC0FF;">{{modal_data.transfer_date}}</div><br/>
              <div class="col-sm-12">รหัสคำสั่งซื้อ {{ modal_data.transfer_code }}</div>
              <div class="col-sm-12">
                <span>สถานะ </span>
                <span :class="[modal_data.status === 'Cancel' ? 'status-cancel' : modal_data.status === 'Success' ? 'status-success' : modal_data.status === 'Waiting' ? '' : 'status-waiting']">
                  {{ modal_data.transfer_status }}
                </span>
                <span v-if="modal_data.is_cancel_branch == 0 && modal_data.status == 'Cancel'"> (ส่วนกลาง) </span>
                <span v-if="modal_data.is_cancel_branch == 1 && modal_data.status == 'Cancel'"> ({{ modal_data.branch_in_name }}) </span>
              </div>
              <div class="col-sm-12" v-if="modal_data.status == 'Cancel'">
                <span>สาเหตุ </span>
                <span>{{ modal_data.remark }}</span>
              </div>
              <div class="col-sm-12">สาขาที่สั่งซื้อ {{ modal_data.branch_in_name }}</div>
              <div class="col-sm-12">สาขาที่โอนออก {{ modal_data.branch_out_name }} <span class="sending-success" v-if="modal_data.status == 'PaddingConfirm' || modal_data.status == 'Success'" >นำส่งแล้ว</span></div>
              <div class="table-responsive pt-2">
                <table class="table">
                  <thead class="thead-dark">
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">รหัสสินค้า</th>
                      <th scope="col">รายการสินค้า</th>
                      <th scope="col">หน่วยนับ</th>
                      <th scope="col" class="text-center">จำนวน</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(d, i) in modal_data.product" :key="'cus' + i">
                      <td class="text-left p-1">
                        {{ i+1 }}
                      </td>
                      <td class="text-left p-1">
                        {{ d.item.code }}
                      </td>
                      <td class="text-left p-1">
                        {{ d.item.name }}
                      </td>
                      <td class="text-left p-1">
                        {{ d.item.stk_unit_code }}
                      </td>
                      <td class="text-center p-1">
                        {{ d.amount }}
                      </td>
                    </tr>
                    <tr>
                      <th
                        scope="row"
                        colspan="10"
                        class="text-center"
                        v-if="modal_data.product.length < 1"
                      >
                        ไม่มีข้อมูล
                      </th>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="col-sm-12"  v-if="modal_data.status === 'Waiting'">
                <div class="row col-12"  style="font-size:1.25rem;font-weight:900;">เลือกสาขาที่โอนออก <span style="color:red;">&nbsp;*</span></div>
                <div class="row col-12 pb-2" style="font-size:0.7rem;" >
                  หมายเหตุ : แสดงสาขาที่โอนออก เฉพาะสาขาที่มีสินค้าคงคลังตามรายการสินค้าที่สั่ง
                </div>
                <div class="row col-12 pb-2" >
                  <select
                    class="custom-select mr-sm-2 pb-0"
                    id="branchOut"
                    v-model="branchOut"
                    @change="branchOutError = false"
                  >
                    <option value="0" disabled hidden>เลือกสาขา...</option>
                    <option
                      v-for="(b, i) in branch_out_list.filter(e => e.id != modal_data.branch_in_id)"
                      :key="'branch' + i"
                      :value="b"
                      >{{ b.branch_name }}</option
                    >
                  </select>
                </div>

                <div class="row col-12 pb-2" style="color:red;" v-if="branchOutError" >
                  * กรุณาเลือกสาขาที่โอนออก
                </div>
              </div>
              <div
              class="container row mt-2"
              style="justify-content: center;"
              v-if="modal_data.status != 'Cancel'"
              >
                <button
                  type="button"
                  class="btn btn-secondary"
                  v-if="modal_data.status == 'Waiting' || modal_data.status == 'PaddingWaiting' "
                  @click="
                    modal_cancel_active = true;
                    modal_cancel.transfer_id = modal_data.transfer_id;
                    modal_cancel.remark = ''
                    remark = ''
                    "
                >
                  ยกเลิกคำสั่งซื้อ
                </button>
                <button
                  type="button"
                  class="btn btn-primary ml-2"
                  v-if="modal_data.status == 'Waiting'"
                  @click="updateTransfer(modal_data.transfer_id)">
                  อนุมัติ
                </button>
              </div>
            </div>
          </div>
        </a-modal>

        <a-modal
        title="แจ้งเตือน"
        centered
        v-model="modal_cancel_active"
        :footer="null"
        width="600px"
        >
          <h4>ยืนยันการยกเลิก <span style="color: red;"> * </span></h4>
          <textarea
            maxlength="500"
            class="form-control"
            placeholder="สาเหตุการยกเลิก..."
            v-model="modal_cancel.remark"
            @change="changeText()"
            rows="3"
          ></textarea>
          <span v-if="isEmpty" style="color: red; margin-top:0.5rem; margin-bottom:0.5rem;"> * กรุณากรอกสาเหตุการยกเลิก</span>
          <div
            class="container row mt-2"
            style="justify-content: center;"
          >
            <button
              type="button"
              class="btn btn-secondary"
              @click="
                modal_cancel_active = false;
                isEmpty=false
                "
            >
              ปิด
            </button>
            <button
              type="button"
              class="btn btn-primary ml-2"
              @click="cancelTransfer()">
              ยืนยัน
            </button>
          </div>
        </a-modal>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
// import apiCus from '../services/service_customer'
import apiItem from '../services/service_item.js'
import apiCenterV2 from "../services/service_undefined_v2";
import Swal from 'sweetalert2'
import moment from 'moment'
import dayjs from 'dayjs'
import buddhistEra from 'dayjs/plugin/buddhistEra';
dayjs.extend(buddhistEra);

export default {
  data () {
    return {
      transfer_data: [],
      transfer_search: [],
      form_data: "",
      cus_age: 0,
      startDate: moment(new Date()).startOf('month'),
      endDate: moment(new Date()).endOf('month'),
      orderDate: moment(new Date()).format("DD/MM/YYYY HH:mm:ss"),
      orderStatus: 1,
      last_date: new Date(),
      title: 'ปรับปรุงสินค้า',
      search: '',
      currentPage: 1,
      items_perpage: 10,
      modal_cancel_active: false,
      modal_active: false,
      isEmpty: false,
      modal_cancel:{
        transfer_id: '',
        remark: ''
      },
      modal_data: {
        transfer_code: '',
        transfer_date: moment(new Date).format("DD/MM/YYYY HH:mm:ss"),
        date: new Date(),
        transfer_id: '',
        branch_out_name: '',
        branch_in_id: '',
        branch_in_name: '',
        remark: '',
        is_cancel_branch: 0,
        transfer_status: '',
        status: '',
        product: ''
      },
      modal_title: '',
      list_bill: [],
      data_ap: [],
      data_rp: [],
      modal_item_active: false,
      data_item: [],
      unit: [],
      header: {
        headers: {
          'Access-Token': sessionStorage.token
        }
      },
      branch: "0",
      branchOut: "0",
      branch_out_list: [],
      branchOutError: false
    }
  },
  computed: {
    // transfer_data: function () {
    //   let text = this.search.trim()
    //   return this.list_bill.filter(adjusList => {
    //     return (
    //       adjusList.doc_no.indexOf(text) > -1
    //     )
    //   })
    // },
    paginate: function () {
      this.totalItem = this.transfer_data.length
      if (this.currentPage >= this.totalPages) {
        this.currentPage = Math.max(0, this.totalPages - 1)
      }
      var index = (this.currentPage - 1) * this.items_perpage
      return this.transfer_data.slice(index, index + this.items_perpage)
    }
  },
  methods: {
    onSearch () {
      if (this.search === '') {
        this.transfer_data = this.transfer_search
      } else {
        this.transfer_data = this.transfer_search.filter(e => e.transfer_code.includes(this.search) || e.transfer_status.includes(this.search) || e.product.filter(p => { if (p.item.name != null) { if (p.item.name.includes(this.search)) return p } }).length > 0)
        // console.log(this.branch)
        // if(this.branch.includes(this.search)
      }
      this.onChange(1)
    },
    onSerchDate () {
      // console.log(new Date(this.startDate).setUTCHours(0,0,0,0))
      this.getTransferAll();
      // this.transfer_data = this.transfer_search.filter(e =>
      // new Date(e.date).setHours(0,0,0,0) >= new Date(this.startDate).setHours(0,0,0,0)
      // && new Date(e.date).setHours(0,0,0,0) <= new Date(this.endDate).setHours(0,0,0,0))
      // this.onChange(1)
    },
    changeText () {
      // console.log(this.modal_cancel.remark)
      if (this.modal_cancel.remark === '') {
        this.isEmpty = true
      } else {
        this.isEmpty = false
      }
    },
    itemRender (current, type, originalElement) {
      if (type === 'prev') {
        return 'Previous'
      } else if (type === 'next') {
        return 'Next'
      }
      return originalElement
    },
    onChange (pageNumber) {
      this.currentPage = pageNumber
    },
    handleChange (value) {
      console.log(`selected ${value}`)
    },
    select (address) {
      this.modal_data.sub_district = address.district
      this.modal_data.district = address.amphoe
      this.modal_data.province = address.province
      this.modal_data.post_code = address.zipcode
    },
    cancelTransfer () {
      if(this.modal_cancel.remark === '') {
        this.isEmpty = true;
      } else {
        this.isEmpty = false;
        this.$store.commit("Loading");
        apiCenterV2.cancelTransferStock(
        {
          remark: this.modal_cancel.remark,
          transfer_id: this.modal_cancel.transfer_id
        },
        this.header,
        results => {
          this.transfer_data = []
          if (results.data.status) {
            this.$notification["success"]({
              message: "แจ้งเตือน",
              description: "ยกเลิกคำสั่งซื้อสำเร็จ"
            });
            // eslint-disable-next-line padded-blocks
            this.getTransferAll()
            this.modal_cancel_active = false
            this.modal_active = false
          }
          this.$store.commit("Loading");
        },
          errors => {
            this.$store.commit("Loading");
            this.$notification["warning"]({
              message: "ยกเลิกคำสั่งซื้อไม่สำเร็จ",
              description: errors.data.message
            });
          }
        );
      }

    },
    updateTransfer (transfer_id) {
      if(this.branchOut === "0"){
        this.branchOutError = true
      } else {
        this.branchOutError = false
        Swal.fire({
            title: "แจ้งเตือน",
            text: "ยืนยันอนุมัติคำสั่งซื้อ",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "ยืนยัน",
            cancelButtonText: "ปิด",
            reverseButtons: true
          }).then(result => {
            if (result.value) {
              this.$store.commit("Loading");
              apiCenterV2.approveTransferStock(
              {
                branch_out_id: this.branchOut.id,
                branch_out_name: this.branchOut.branch_name,
                transfer_id: transfer_id
              },
              this.header,
              results => {
                this.transfer_data = []
                if (results.data.status) {
                  this.$notification["success"]({
                    message: "แจ้งเตือน",
                    description: "อนุมัติคำสั่งซื้อสำเร็จ"
                  });
                  // eslint-disable-next-line padded-blocks
                  this.getTransferAll()
                  this.modal_active = false
                } else {
                  this.$notification["warning"]({
                    message: "ไม่สามารถดึงข้อมูลจากระบบได้",
                    description: ""
                  });
                  this.getTransferAll();
                }
                this.$store.commit("Loading");
              },
                errors => {
                  this.$store.commit("Loading");
                  this.$notification["warning"]({
                    message: "บันทึกคำสั่งซื้อไม่สำเร็จ",
                    description: errors.data.message
                  });
                }
              );
            }
          });
      }
    },
    editBill (code) {
      this.$store.commit('Loading')
      let body = {
        'doc_no': code
      }
      apiItem.getAdjust(this.branch.dyn_address + '/',
        {
          headers: {
            'Access-Token': this.branch.access_token
          }
        },
        body,
        result => {
          this.$store.commit('Loading')
          if (result.response === 'success') {
            this.modal_title = 'แก้ไขเอกสาร'
            this.modal_active = true
            this.modal_data = result.data
            this.modal_data.doc_date = moment(result.data.doc_date)
          } else {
            this.$notification['warning']({
              message: 'ไม่สามารถดึงข้อมูลเอกสาร',
              description:
                result.message
            })
          }
        },
        error => {
          this.$store.commit('Loading')
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    },
    getHaveStock () {
      apiCenterV2.getHaveStock(
        {
          transfer_id: this.modal_data.transfer_id
        },
        this.header,
        results => {
          if(results.data.status){
            this.branch_out_list = results.data.data
          }
        },
        errors => {
        })
    },
    getTransferAll () {
      let branchId = 0
      if (this.branch === "0") {
        branchId = 0;
      } else {
        branchId = this.branch.id
      }
      this.$store.commit("Loading");
      apiCenterV2.selectTransferStock(
        {
          branch_id: branchId.toString(),
          startDate: this.startDate,
          endDate: this.endDate
        },
        this.header,
        results => {
          this.transfer_data = []
          this.transfer_search = []
          
          if (results.data.status) {
            // eslint-disable-next-line padded-blocks
            results.data.data.forEach(val => {
              let status = val.transfer.transfer_status === 'Waiting' ? 'รออนุมัติ' :  val.transfer.transfer_status === 'PaddingWaiting' || val.transfer.transfer_status === 'PaddingConfirm'  ? 'ดำเนินการ' : val.transfer.transfer_status === 'Success' ? 'สำเร็จ' : 'ยกเลิก'
              this.transfer_data.push({
                transfer_id: val.transfer.id,
                transfer_code: val.transfer.transfer_code,
                transfer_date: dayjs(val.transfer.transfer_date).format('DD/MM/BBBB HH:mm:ss'),
                date: val.transfer.transfer_date,
                branch_out_name: val.transfer.branch_out_name,
                branch_in_id: val.transfer.branch_in_id,
                branch_in_name: val.transfer.branch_in_name,
                remark: val.transfer.remark,
                is_cancel_branch: val.transfer.is_cancel_branch,
                transfer_status: status,
                status: val.transfer.transfer_status,
                // isEdit: edit,
                product: val.transfer_product.transfer_stock_products
              })
              this.transfer_search.push({
                transfer_id: val.transfer.id,
                transfer_code: val.transfer.transfer_code,
                transfer_date: dayjs(val.transfer.transfer_date).format('DD/MM/BBBB HH:mm:ss'),
                date: val.transfer.transfer_date,
                branch_out_name: val.transfer.branch_out_name,
                branch_in_id: val.transfer.branch_in_id,
                branch_in_name: val.transfer.branch_in_name,
                remark: val.transfer.remark,
                is_cancel_branch: val.transfer.is_cancel_branch,
                transfer_status: status,
                status: val.transfer.transfer_status,
                // isEdit: edit,
                product: val.transfer_product.transfer_stock_products
              })
            })
            this.onSearch()
            this.form_data = JSON.stringify(this.transfer_data);
            this.totalItem = this.transfer_data.length
          } else {
            this.$notification["warning"]({
              message: "ไม่สามารถดึงข้อมูลจากระบบได้",
              description: ""
            });
          }
          this.$store.commit("Loading");
        },
        errors => {
          console.log(errors);
          this.$store.commit("Loading");
          this.$notification["warning"]({
            message: "ไม่สามารถดึงข้อมูลจากระบบได้",
            description: errors.data.message
          });
        }
      );
    },
    selectDateStart (current) {
      return current && current.valueOf() > this.endDate;
    },
    selectDateEnd (current) {
      return current && current.valueOf() < this.startDate;
    },
    deleteItem (val) {

      Swal.fire({
        title: "ยกเลิกโอนย้ายสต๊อก",
        text: "ท่านต้องการยกเลิกโอนย้ายสต๊อก ใช่หรือไม่ ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "ตกลง",
        cancelButtonText: "ปฏิเสธ",
        cancelButtonColor: "red",
        reverseButtons: true
      }).then(result => {
        if (result.value) {
          this.$store.commit("Loading");
          apiCenterV2.cancelTransferStockWhenApprove(
            {
              transfer_id: val.transfer_id,
              remark: 'โอนสต๊อกผิดพลาด'
            },
            this.header,
            results => {
              // console.log(results);
              if (results.data.status) {
                this.alert_msg("success", "ยกเลิกสำเร็จ", "");
                // this.getProductAll();
                this.getTransferAll();
              } else {
                this.alert_msg("warning", "ไม่สามารถเข้าถึงข้อมูล", "");
              }
              this.$store.commit("Loading");
            },
            errors => {
              this.$store.commit("Loading");
              // this.$store.commit("Loading");
              this.alert_msg(
                "warning",
                "ไม่สามารถเข้าถึงข้อมูล",
                errors.message
              );
            }
          );
        }
      });
    },
  },
  created () {
    this.getBranch()
    this.getTransferAll()
  },
  mounted () {
  }
}
</script>
<style scoped>
#components-pagination-demo-mini .ant-pagination:not(:last-child) {
  margin-bottom: 24px;
}
.status-waiting {
  color: #FFCA2B;
}

.status-success {
  color: #359E39;
}

.status-cancel {
  color: #DE4554;
}

.btn-warning-stock {
  background-color: #FFC201;
}

.btn-secondary-stock {
  background-color: #DFE3E7;
}


.sending-success {
  background-color: #359E39;
  color: white;
  border:1px solid #359E39;
  font-size: 0.875rem;
  padding: 2px 4px;
  border-radius: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/views/stock_manage.vue